import accountPartial from './pt/account'
import cartPartial from './pt/cart'
import contentPartial from './pt/content'
import freeShippingPartial from './pt/freeShipping'
import historyPartial from './pt/history'
import ordersPartial from './pt/orders'
import productPartial from './pt/product'

export default {
  common: {
    cmsLoading: 'Loading...',
    cmsPageNotFound: 'Página não encontrada',
    homeLoading: 'Carregando conteúdo...',
    homeLoadError: 'Não foi possivel carregar a página principal',
    sessionInactive: 'Sua sessão não está mais ativa. Inicie sessão novamente',
    themeLoader: {
      preparing: 'A preparar a sua loja',
      loadingTheme: 'A carregar o tema...',
    },
  },
  header: {
    categories: 'Categorias',
    searchPlaceholder: 'O que procura?',
    closeSearch: 'Fechar pesquisa',
    clearSearch: 'Limpar pesquisa',
    events: 'Eventos',
    favorites: 'Favoritos',
    cart: 'Carrinho',
    openMenu: 'Abrir menu',
    profile: 'Perfil',
    back: 'Voltar',
    greeting: 'Olá,',
    login: 'Iniciar',
    loginBold: 'sessão',
    recentSearches: 'Recentes',
    noCategoriesFound: 'Nenhuma categoria encontrada',
    results: 'Resultados',
    viewAllResults: 'Ver todos os {{count}} produtos',
    searching: 'A pesquisar...',
    noProductsFound: 'Nenhum produto encontrado para',
    priceOnRequest: 'Preço sob consulta',
    plusVat: '+IVA',
  },
  nav: {
    menu: 'Menu',
    mainMenu: 'Menu Principal',
    usefulLinks: 'Links Úteis',
  },
  footer: {
    newsletterTitle: 'Newsletter',
    newsletterCopyLine1: 'Receba todas as novidades',
    newsletterCopyLine2: 'e Promoções no email!',
    newsletterPlaceholder: 'email@email.com',
    subscribe: 'Subscrever',
    newsletterError: 'Ocorreu um erro. Tente mais tarde',
    joinUs: 'Junte-se a Nós',
  },
  languageSwitcher: {
    label: 'Idioma',
  },
  auth: {
    common: {
      emailLabel: 'Email*',
      connectionError: 'Erro de ligação. Tente novamente mais tarde.',
      backToLogin: 'Voltar ao início de sessão',
      unexpectedError: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
      showPassword: 'Mostrar palavra-passe',
      hidePassword: 'Ocultar palavra-passe',
    },
    login: {
      title: 'Bem-vindo de volta.',
      subtitle: 'Acede à tua conta e retoma as tuas actividades com facilidade.',
      noAccount: 'Ainda não és membro?',
      joinUs: 'Junta-te a nós.',
      passwordLabel: 'Palavra-passe*',
      emailPlaceholder: 'Insira o email',
      passwordPlaceholder: 'Insira a palavra-passe',
      rememberMe: 'Lembrar-me',
      forgotPassword: 'Esqueceu-se da password?',
      submit: 'Iniciar sessão',
      submitting: 'A iniciar sessão...',
      success: 'Sessão iniciada com sucesso!',
      invalidCredentials: 'Email ou password incorretos.',
      notVerified: 'Por favor verifique o seu email antes de iniciar sessão.',
      genericError: 'Ocorreu um erro ao iniciar sessão.',
    },
    signup: {
      title: 'Bem-vindo',
      alreadyCustomer: 'Já é nosso cliente?',
      loginLink: 'Iniciar sessão',
      firstName: 'Primeiro nome',
      firstNameRequired: 'Primeiro nome é obrigatório',
      lastName: 'Último nome',
      lastNameRequired: 'Último nome é obrigatório',
      email: 'Email',
      emailRequired: 'Email é obrigatório',
      phone: 'Telefone',
      phoneRequired: 'Telefone é obrigatório',
      nif: 'NIF (Opcional)',
      password: 'password',
      passwordRequired: 'Password é obrigatória',
      confirmPassword: 'confirm password',
      confirmPasswordRequired: 'Confirmação de password é obrigatória',
      acceptTerms: 'Aceito os Termos e Condições e a Política de Privacidade',
      termsRequired: 'Tem de aceitar os Termos e Condições para continuar',
      marketingOptIn: 'Quero receber comunicações de marketing',
      submit: 'Registar',
      submitting: 'A registar...',
      success: 'Conta criada com sucesso! Por favor, inicie sessão.',
      genericError: 'Ocorreu um erro ao criar a conta.',
      captchaLabel: 'Introduza o código',
      refreshCaptcha: 'Atualizar captcha',
      invalidCaptcha: 'Código captcha incorreto, tente novamente.',
    },
    validation: {
      emailInvalid: 'Email inválido',
      passwordRequired: 'Password é obrigatória',
      passwordMinLength: 'A password deve ter pelo menos 8 caracteres',
      passwordsMismatch: 'As passwords não coincidem',
      currentPasswordRequired: 'A palavra-passe atual é obrigatória',
      newPasswordMustDiffer: 'A nova palavra-passe deve ser diferente da atual',
      phoneMinLength: 'Telefone deve ter pelo menos 9 dígitos',
      phoneMaxLength: 'Telefone deve ter no máximo 15 dígitos',
    },
    forgotPassword: {
      title: 'Recuperar palavra-passe',
      subtitle: 'Introduza o email da sua conta e enviaremos instruções para repor a palavra-passe.',
      checkEmailTitle: 'Verifique o seu email',
      checkEmailPrefix: 'Se existir uma conta associada a',
      checkEmailSuffix: ', receberá instruções para repor a palavra-passe.',
      emailPlaceholder: 'Insira o email da sua conta',
      submit: 'Enviar instruções',
      submitting: 'A enviar...',
      genericError: 'Ocorreu um erro ao pedir a reposição da palavra-passe.',
    },
    resetPassword: {
      title: 'Nova palavra-passe',
      subtitle: 'Defina uma nova palavra-passe para a sua conta.',
      passwordLabel: 'Nova palavra-passe*',
      passwordPlaceholder: 'Insira a nova palavra-passe',
      confirmPasswordLabel: 'Confirmar palavra-passe*',
      confirmPasswordPlaceholder: 'Confirme a nova palavra-passe',
      submit: 'Definir nova palavra-passe',
      submitting: 'A guardar...',
      requestNewLink: 'Pedir novo link',
      invalidLinkTitle: 'Link inválido',
      invalidLinkCopy: 'O link de reposição da palavra-passe é inválido ou está incompleto. Peça um novo link para continuar.',
      success: 'Palavra-passe atualizada com sucesso.',
      tokenExpired: 'O link de reposição expirou. Peça um novo.',
      tokenInvalid: 'O link de reposição é inválido. Peça um novo.',
      genericError: 'Ocorreu um erro ao atualizar a palavra-passe.',
    },
    verifyAccount: {
      pending: 'A confirmar a sua conta...',
      successTitle: 'Conta confirmada',
      successDescription: 'A sua conta foi verificada com sucesso. A redirecionar...',
      errorTitle: 'Não foi possível confirmar',
      invalidLinkTitle: 'Link inválido',
      invalidLinkDescription: 'O link de confirmação da conta é inválido ou está incompleto.',
      tokenExpired: 'O link de confirmação expirou. Registe-se novamente para receber um novo.',
      tokenInvalid: 'O link de confirmação é inválido.',
      genericError: 'Ocorreu um erro ao confirmar a sua conta.',
    },
  },
  ...accountPartial,
  account: {
    changePassword: {
      title: 'Palavra-passe',
      cancel: 'Cancelar',
      save: 'Guardar',
      description: 'Atualize a palavra-passe da sua conta. Será necessário introduzir a palavra-passe atual para confirmar a alteração.',
      replace: 'Substituir',
      currentPasswordLabel: 'Palavra-passe atual*',
      currentPasswordPlaceholder: 'Insira a palavra-passe atual',
      newPasswordLabel: 'Nova palavra-passe*',
      newPasswordPlaceholder: 'Insira a nova palavra-passe',
      confirmPasswordLabel: 'Confirmar nova palavra-passe*',
      confirmPasswordPlaceholder: 'Confirme a nova palavra-passe',
      forgotPasswordPrefix: 'Esqueceu-se da palavra-passe atual?',
      invalidCurrentPassword: 'A palavra-passe atual está incorreta.',
    },
    ...accountPartial.account,
  },
  ...cartPartial,
  ...contentPartial,
  ...freeShippingPartial,
  ...historyPartial,
  ...ordersPartial,
  ...productPartial,
}
